<template>
  <!-- Rendered only when there is something to say: an app with no links and
       the credit switched off leaves no empty strip under the card. -->
  <footer v-if="links.length || poweredBy" class="sh-foot-links">
    <nav v-if="links.length" class="sh-foot-links__row" :aria-label="t('preauth.helpAndLegal')">
      <a
        v-for="link in links"
        :key="link.key"
        :href="link.href"
        :class="`sh-foot-links__${link.key}`"
        :target="link.href.startsWith('mailto:') ? undefined : '_blank'"
        rel="noopener noreferrer"
        >{{ t(`preauth.${link.key}`) }}</a
      >
    </nav>
    <span v-if="poweredBy" class="sh-foot-links__credit">{{ t("preauth.poweredBy", { vendor: VENDOR_NAME }) }}</span>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { preAuthLinks, showPoweredBy } from "@/app/loginLinks";
import { VENDOR_NAME } from "@/app/vendor";
import { APP_LOGIN_PAGE, APP_NAME } from "@/app";

/** Support, legal and the vendor credit — the same strip under every
 *  pre-auth card (Login, NoAccess, Unavailable). */
export default defineComponent({
  name: "PreAuthFooter",
  setup() {
    const { t } = useI18n();
    const links = preAuthLinks(APP_LOGIN_PAGE);
    const poweredBy = showPoweredBy(APP_LOGIN_PAGE, APP_NAME);
    return { t, links, poweredBy, VENDOR_NAME };
  },
});
</script>
